import { render, staticRenderFns } from "./TypeCreate.vue?vue&type=template&id=6f549a10&scoped=true&"
import script from "./TypeCreate.vue?vue&type=script&lang=js&"
export * from "./TypeCreate.vue?vue&type=script&lang=js&"
import style0 from "./TypeCreate.vue?vue&type=style&index=0&id=6f549a10&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f549a10",
  null
  
)

export default component.exports